import { gql } from '@apollo/client';
import { CloudSubscription } from '@atlassian/cssxp-typescommon';

export interface CloudListDetailsQuery {
  cloudSubscription: {
    totalHits: number;
    results: CloudSubscription[];
  };
}

export const fetchCloudSubscriptionDetailsForContact = gql`
  query fetchCloudSubscriptionDetailsForContact(
    $searchParams: CloudSubscriptionSearchParams!
    $searchOptions: CloudSubscriptionSearchOptions
    $filterOptions: [FilterOption]
  ) {
    cloudSubscription(searchParams: $searchParams, searchOptions: $searchOptions, filterOptions: $filterOptions) {
      totalHits
      results {
        accountId
        id
        sen
        businessKey
        accountOwnerEmail
        billingContactEmail
        baseProduct
        billingCycle
        billingStatus
        cloudSiteId
        cloudSiteUrl
        cloudSiteCustomHostname
        latestPeriodEndDate
        unitCount
        createdDate
        endTimestamp
        roles
        provisioningStatus
        entitlementNumber
        firstPeriodEndDate
        firstPeriodStartDate
        latestPeriodStartDate
        updatedDate
        licenseLevel
        platform
        planType
        pageName
        isCloud
        renewalAction
        productName
        productId
        isAddon
        subscriptionId
        sourceSystem
        sources
        userTier
        edition
        productId
        editionKey
        bitbucketAccountType
        upgradeTrial {
          offeringId
          offeringName
          baseOfferingName
        }
        transactionDetail {
          transactionAccountId
          billToCompany
          shipToCompany
        }
        shipToParty {
          id
          name
          addressLine1
          addressLine2
          city
          country
          state
          phone
          postcode
          taxId
        }
        defaultPaymentMethod {
          id
          type
          paymentIssue
          default
          ... on CreditCard {
            card {
              expirationMonth
              expirationYear
              last4Numbers
              brand
            }
          }
          ... on PaymentOnTerms {
            terms {
              invoiceDueDays
            }
          }
        }
        nextBillingTimestamp
        billingFrequency
        trial
        trialEndDate
        isSandbox
        isApp
        logoId
        scheduledChanges {
          subscriptionScheduleAction
        }
        subscription {
          subscriptionPeriod {
            chargeQuantities {
              chargeElement
              quantity
              lastUpdatedAt
            }
          }
        }
      }
    }
  }
`;
